export default "/images/vendor/@coreui/icons/svg/flag/cif-jp.svg?9856a0f88edad9ef55093f1f65f991f3";